import { CanvasElementType, CanvasObjectPosition, CanvasObjectSize, CanvasWidgetSettings } from '@y42/json-schema';
import { VisualizationWidgetUIModel } from '../../widget/visualization-widget.model';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles } from './default-canvas-model-properties';

export const defaultWidgetSize = {
  width: 400,
  height: 300,
};

export function getCanvasWidgetModel(data: { position: CanvasObjectPosition; size: CanvasObjectSize }) {
  return {
    type: CanvasElementType.Widget,
    styles: {
      ...defaultCanvasGenericStyles,
      // Do not use `none` as it makes the rect element unselectable and breaks the color picker.
      'background-color': '#ffffff00',
      'border-color': '#ffffff00',
    },
    position: data.position,
    size: data.size,
    typeSettings: null,
  };
}

export interface CanvasWidgetUISettings extends CanvasWidgetSettings {
  widget?: VisualizationWidgetUIModel;
}

export type CanvasWidgetStoreModel = VisualizationCanvasElementStoreModel<CanvasElementType.Widget>;

export type CanvasWidgetUIModel = CanvasWidgetStoreModel & {
  typeSettings: CanvasWidgetUISettings;
};
